/**
 * Action types for DynamicCoverage
 */

export const DYNAMIC_COVERAGE_ERROR = 'DYNAMIC_COVERAGE_ERROR';
export const DYNAMIC_COVERAGE_REQUEST = 'DYNAMIC_COVERAGE_REQUEST';

export const GET_DYNAMIC_COVERAGE_LIST_DATA_SUCCESS = 'GET_DYNAMIC_COVERAGE_LIST_DATA_SUCCESS';
export const GET_DYNAMIC_COVERAGE_STATE_PROFILES_SUCCESS = 'GET_DYNAMIC_COVERAGE_STATE_PROFILES_SUCCESS';
export const SET_DYNAMIC_COVERAGE_SHOW_ALERT = 'SET_DYNAMIC_COVERAGE_SHOW_ALERT';

export const ERROR_ALERT = 'ERROR_ALERT';
export const NO_ROW_ALERT = 'NO_ROW_ALERT';

export const dynamicCoverageRequest = () => {
  return {
    type: DYNAMIC_COVERAGE_REQUEST,
  };
}

export const setDynamicCoverageShowAlert = (data) => {
  return {
    type: SET_DYNAMIC_COVERAGE_SHOW_ALERT,
    payload: data,
  };
};

export const getDynamicCoverageStateProfilesSuccess = (data) => {
  return {
    type: GET_DYNAMIC_COVERAGE_STATE_PROFILES_SUCCESS,
    payload: data,
  };
};

export const dynamicCoverageError = (error, defaultError = null) => {
  return {
    type: DYNAMIC_COVERAGE_ERROR,
    error: error.response,
    defaultError,
  };
};

export const getDynamicCoverageList = (drugIdentifier, defaultError) => {
  return function (dispatch, getState, api) {
    dispatch(dynamicCoverageRequest());

    return api.get(`/drugs/${drugIdentifier}`)
      .then(({data}) => {
        dispatch(getDynamicCoverageListSuccess({
          states: data.states,
          planTypes: data.plantypes,
          medData: data.medData,
          rxData: data.rxData,
          lastrefresheddates: data.lastrefresheddates,
        }));
      })
      .catch((error) => dispatch(dynamicCoverageError(error, defaultError)));
  };
};

export const getDynamicCoverageListSuccess = (data) => {
  return {
    type: GET_DYNAMIC_COVERAGE_LIST_DATA_SUCCESS,
    payload: data,
  };
}
